import * as React from 'react'
import { lazyComponent } from 'utils/lazy-component'
import { useWorkspaceSwitchFeedbackStore } from './workspace-switch-feedback-store'

const WorkspaceSwitchFeedback = lazyComponent(() =>
  import('./workspace-switch-feedback').then(m => m.WorkspaceSwitchFeedback),
)

/**
 * Mount once per app shell. The switcher only writes to the store, so without this host a
 * switch shows neither the confirmation dialog nor the loading skeleton.
 */
export function WorkspaceSwitchFeedbackHost() {
  const [hasBeenActive, setHasBeenActive] = React.useState(false)
  const isActive = useWorkspaceSwitchFeedbackStore(
    state => state.switchedTo !== null || state.pendingTransitions > 0,
  )
  if (isActive && !hasBeenActive) {
    setHasBeenActive(true)
  }

  if (!hasBeenActive) {
    return null
  }

  return (
    <React.Suspense fallback={null}>
      <WorkspaceSwitchFeedback.component />
    </React.Suspense>
  )
}
